import { connect } from 'react-redux'
import getCreationDate from 'shared/components/story/creation-time'
import { VerifiedLogo } from 'shared/components/users/verified-badge'
import { grid7 } from 'shared/css/grid.css'
import * as selectors from 'shared/redux/reducers'
import styled from 'styled-components'
import { Attribution, Timestamp, Username } from './attribution'
import Description from './description'
import Title from './title'

const Container = styled.div`
    position: relative;
`

const Info = styled.div`
    width: ${grid7};
`

const StoryInfo = ({ title, description, publish_datetime, user }) => {
    return (
        <Container>
            <Info>
                <Title>{title}</Title>
                <Attribution>
                    {user && (
                        <Username href={`/channel/${user.username}`} target="_blank">
                            @{user.username} {user.is_verified && <VerifiedLogo />}
                        </Username>
                    )}
                    <Timestamp>{getCreationDate(publish_datetime)}</Timestamp>
                </Attribution>
                {description && <Description>{description}</Description>}
            </Info>
        </Container>
    )
}

export default connect((state) => ({
    loggedInUser: selectors.getUser(state),
}))(StoryInfo)
